import { z } from 'zod';
/**
 * Codes d'erreur stables renvoyés par l'API (champ `errorCode`). Le client choisit le message
 * à afficher à partir du code, jamais en analysant le texte. Voir docs/parcours/parcours-erreur.md.
 */
export const ERROR_CODES = [
    'INVITATION_INVALID',
    'INVITATION_EXPIRED',
    'INVITATION_REVOKED',
    'MEETING_ENDED',
    'ADMISSION_DENIED',
    'ADMISSION_ALREADY_ACTIVE',
    'ADMISSION_NOT_ADMITTED',
    'GUEST_SESSION_EXPIRED',
    'REMOVED_FROM_ROOM',
    'RATE_LIMITED',
    'AUTH_REQUIRED',
    'AUTH_NOT_ALLOWED',
    'AUTH_INVALID_CREDENTIALS',
    'AUTH_PROVIDER_UNAVAILABLE',
    'TOTP_REQUIRED',
    'TOTP_INVALID',
    'CSRF_INVALID',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'VALIDATION_FAILED',
    'MEDIA_DEMO_DISABLED',
    'INTERNAL_ERROR',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
/** Messages affichés à l'utilisateur, en français, sans détail technique ni énumération. */
export const ERROR_MESSAGES = {
    INVITATION_INVALID: 'Ce lien n’est pas valide. Vérifiez qu’il est complet ou demandez un nouveau lien à votre contact Apogée.',
    INVITATION_EXPIRED: 'Ce lien a expiré. Demandez un nouveau lien à votre contact Apogée.',
    INVITATION_REVOKED: 'Ce lien n’est plus actif. Demandez un nouveau lien à votre contact Apogée.',
    MEETING_ENDED: 'Cette visio est terminée.',
    ADMISSION_DENIED: 'L’organisateur n’a pas accepté votre demande.',
    ADMISSION_ALREADY_ACTIVE: 'Une demande est déjà en cours avec ce lien, dans un autre onglet ou sur un autre appareil.',
    ADMISSION_NOT_ADMITTED: 'Votre demande n’a pas encore été acceptée.',
    GUEST_SESSION_EXPIRED: 'Votre session a expiré. Rouvrez le lien reçu pour continuer.',
    REMOVED_FROM_ROOM: 'L’organisateur vous a retiré de la visio.',
    RATE_LIMITED: 'Trop de tentatives. Réessayez dans quelques instants.',
    AUTH_REQUIRED: 'Votre session a expiré. Reconnectez-vous.',
    AUTH_NOT_ALLOWED: 'Ce compte n’est pas autorisé à accéder à l’espace Apogée.',
    AUTH_INVALID_CREDENTIALS: 'E-mail ou mot de passe incorrect.',
    AUTH_PROVIDER_UNAVAILABLE: 'La connexion par mot de passe n’est pas configurée sur ce serveur.',
    TOTP_REQUIRED: 'La vérification en deux étapes est requise.',
    TOTP_INVALID: 'Code incorrect. Vérifiez l’heure de votre téléphone et réessayez.',
    CSRF_INVALID: 'La requête a été refusée. Rechargez la page puis réessayez.',
    FORBIDDEN: 'Vous n’avez pas les droits nécessaires pour cette action.',
    NOT_FOUND: 'Élément introuvable.',
    CONFLICT: 'Cette action n’est plus possible dans l’état actuel.',
    VALIDATION_FAILED: 'Certaines informations sont invalides.',
    MEDIA_DEMO_DISABLED: 'La démonstration média est désactivée.',
    INTERNAL_ERROR: 'Une erreur inattendue est survenue. Réessayez dans quelques instants.',
};
export const apiErrorSchema = z.object({
    statusCode: z.number().int(),
    errorCode: errorCodeSchema,
    message: z.string(),
    /** Erreurs de validation par champ (chemin → message), sans écho de la valeur saisie. */
    fields: z.record(z.string(), z.string()).optional(),
});
//# sourceMappingURL=errors.js.map